import React from "react";
import { Form, Col, Alert, Button } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { useHistory } from "react-router-dom";



export default function ThankYou() {

    const history = useHistory();

    function RedirectPage(path) {
        
        history.push(path);        
    }

  let app = ApplicantContainer.useContainer();

    return (
        <>
        { app.submissionID ? (
         
      <Form.Row>
        <Col xs={12}>                        
        <Alert variant="light" className="align-items-center">
          <Alert.Heading className="mb-4 border rounded-3 d-flex align-items-center justify-content-center p-3 py-6">
          
            <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="currentColor" className="bi bi-check-circle fs-2" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
              <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"></path>
            </svg>
          &nbsp;&nbsp;Thank you for your submission
          </Alert.Heading>
           <div className="mb-4 d-flex align-items-center justify-content-center p-3 py-6">
            
           Scholarship Unit will keep you update on your scholarship application status. <br/>
           Should you have any enquiry, feel free to contact us at 03-74918622 ext. 3041/ 3038 or email us at scholarship@sunway.edu.my.
           <br/><br/>
           Thank you.
          </div>  
        <hr />
        <div className="d-flex justify-content-end">
          <Button onClick={() => window.location.replace('https://scholarship.sunway.edu.my/scholarship-calendar')} variant="success">
            Close
          </Button>
        </div>
        </Alert>
        </Col>
        </Form.Row>
      ):(
          <>
          <Form.Row >
            <Col xs={12}>                        
            <Alert variant="light" className="align-items-center">
            <Alert.Heading className="mb-4 border rounded-3 d-flex align-items-center justify-content-center p-3 py-6">
              
              <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>&nbsp;&nbsp;
              An Error has occured
            </Alert.Heading>
            <div className="mb-4 d-flex align-items-center justify-content-center p-3 py-6">
              Please try again.
            </div>  
        <hr />
        <div className="d-flex justify-content-end">
          <Button onClick={() => RedirectPage("/")} variant="warning">
            Relaunch Form
          </Button>
        </div>
        </Alert>
                 
            </Col>
        </Form.Row>
          </>
      )}
      </>
    );
}